// @flow
import React from 'react'
import colors from '../../styles/colors'

type Props = {
  input: Object,
  label?: string,
  meta: Object,
  placeholder?: string,
  style?: Object,
  inputStyle?: Object,
  className?: string,
  autoFocus?: boolean,
  rows?: number
}

const Textarea = ({
  input,
  label,
  placeholder,
  meta,
  style,
  inputStyle,
  className,
  autoFocus,
  rows
}: Props) => (
  <div style={{ ...style }}>
    {label && <label htmlFor={input.name}>{label}</label>}
    <textarea
      {...input}
      rows={rows}
      autoFocus={autoFocus}
      placeholder={placeholder}
      style={{ ...inputStyle }}
      className={className || 'form-control'}
    />
    {meta.touched && meta.error && (
      <div style={{ fontSize: '85%', color: colors.danger }}>{meta.error}</div>
    )}
  </div>
)

export default Textarea



// WEBPACK FOOTER //
// ./src/components/Textarea/index.js